export default "__VITE_ASSET__C$u6q6Cd__"